<script lang="ts">
    import Button from '@amp/web-app-components/src/components/buttons/Button.svelte';
    import { createEventDispatcher } from 'svelte';

    export let header: string | null = null;
    export let message: string | null = null;
    export let action: string | null = null;
    export let confirm: string | null = null;
    export let dialogTitleId: string | null = null;
    export let buttonLayout: 'row' | 'column' = 'row';

    const dispatch = createEventDispatcher();

    const handleActionButton = () => {
        dispatch('action');
    };

    const handleCloseButton = () => {
        dispatch('close');
    };
</script>

{#if message && confirm}
    <!-- TODO: rdar://92356192 (JMOTW: Use Svelte animations) -->
    <article class="error-modal__container" data-testid="error-modal">
        <div
            role="status"
            class="error-modal__top-content"
            class:error-modal__top-content--expanded={!!header}
        >
            {#if header}
                <h1
                    id={dialogTitleId}
                    data-testid="error-header"
                    class="error-modal__message"
                >
                    {header}
                </h1>
                <p data-testid="error-message" class="error-modal__sub-message">
                    {message}
                </p>
            {:else}
                <h1
                    id={dialogTitleId}
                    data-testid="error-message-only"
                    class="error-modal__message"
                >
                    {message}
                </h1>
            {/if}
        </div>

        <div
            class="error-modal__bottom-content"
            class:error-modal__bottom-content--has-action={!!action}
            class:error-modal__bottom-content--row={buttonLayout === 'row'}
        >
            {#if action}
                <Button
                    buttonStyle="alertButton"
                    on:buttonClick={handleActionButton}
                    makeFocused={true}
                >
                    {action}
                </Button>
            {/if}

            <Button
                buttonStyle={action ? 'alertButtonSecondary' : 'alertButton'}
                on:buttonClick={handleCloseButton}
                makeFocused={!action}
            >
                {confirm}
            </Button>
        </div>
    </article>
{/if}

<style lang="scss">
    @use 'amp/stylekit/core/mixins/materials' as *;
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    $error-modal-duration: 0.275s;

    .error-modal__container {
        min-width: auto;
        min-height: 122px;
        padding: 20px 16px 16px;
        border: $dialog-border;
        border-radius: var(
            --global-border-radius-large,
            #{$global-border-radius-large}
        );
        box-shadow: $dialog-inset-shadow, $dialog-shadow;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;

        @include system-standard-thick-material($detect-inactive: false);
    }

    .error-modal__top-content {
        width: 260px;
        margin: 0 auto;
    }

    .error-modal__top-content,
    .error-modal__bottom-content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        flex-grow: 1;
    }

    .error-modal__bottom-content {
        // Space between stacked primary buttons
        gap: 8px;
    }

    .error-modal__bottom-content--row {
        @media (--small) {
            flex-direction: row-reverse;
        }
    }

    .error-modal__bottom-content--has-action {
        :global(.button.alert button) {
            @media (--medium) {
                padding: 0 10px;
                white-space: nowrap;
            }
        }
    }

    .error-modal__message {
        font: var(--headline);
    }

    .error-modal__sub-message {
        margin: 11px 0 16px;
        font: var(--subhead);
    }

    @keyframes modalZoomIn {
        from {
            opacity: 0;
            transform: scale3d(0, 0, 0);
        }
    }

    @keyframes modalFadeIn {
        from {
            opacity: 0;
        }
    }
</style>
